module.exports = __webpack_public_path__ + "media/fonts/suisse-intl/SuisseIntl-Thin-WebXL-09e0703e30c3d88f9d7a3e0fb39f5719.woff2";